import { EmployeeChangeLogState } from './employee-change-log-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  setStateDirtyByParam,
  updateResourceByParam,
} from '../reducers/utils/state-manager';

import { EmployeeChangeLog } from '../typescript-types/employee-change-log';

const InitialState: EmployeeChangeLogState = {
  employeeChangeLogsById: {},
  employeeChangeLogsStateByEmployeeId: {},
};

export const employeeChangeLogReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_EMPLOYEE_CHANGE_LOGS'): {
      const { employeeId } = action.payload.args;
      return updateResourceByParam(state, 'employeeChangeLogs', 'employeeId', employeeId, true);
    }
    case SUCCESS('LOAD_EMPLOYEE_CHANGE_LOGS'): {
      const {
        args: { employeeId },
        data,
      } = action.payload;
      const employeeChangeLogs = data.reduce(
        (acc: { [id: number]: EmployeeChangeLog }, changeLog: EmployeeChangeLog) => ({
          ...acc,
          [changeLog.employeeChangeLogId]: changeLog,
        }),
        {},
      );
      return updateResourceByParam(
        state,
        'employeeChangeLogs',
        'employeeId',
        employeeId,
        false,
        employeeChangeLogs,
      );
    }
    case FAILURE('LOAD_EMPLOYEE_CHANGE_LOGS'): {
      const { employeeId } = action.payload.args;
      return updateResourceByParam(state, 'employeeChangeLogs', 'employeeId', employeeId, false);
    }
    case SUCCESS('CREATE_MERGE_EMPLOYEE'):
    case 'SET_EMPLOYEE_CHANGE_LOGS_DIRTY':
    case SUCCESS('UPDATE_EMPLOYEE'): {
      const { employeeId } = action.payload.args;
      return setStateDirtyByParam(state, 'employeeChangeLogs', 'employeeId', employeeId);
    }
    default: {
      return state;
    }
  }
};
